package com.downdogapp.client.singleton

import com.downdogapp.*
import com.downdogapp.client.*
import com.downdogapp.client.api.*
import com.downdogapp.client.api.AppType.*
import com.downdogapp.client.controllers.LoadingViewController
import com.downdogapp.client.controllers.PurchaseViewController
import com.downdogapp.client.controllers.YearlyMonthlyPricePair
import com.downdogapp.client.singleton.Platform.WEB
import com.downdogapp.client.views.PurchaseView
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.js.Date

actual object AppHelper : AppHelperInterface {

  lateinit var appTypeVar: AppType

  override val appType get() = appTypeVar

  override fun pushViewController(vc: ViewController) {
    AppPage.pushViewController(vc)
  }

  override fun popViewController(callback: () -> Unit) = AppPage.popViewController(callback)

  override fun runInMain(runnable: () -> Unit) {
    runnable()
  }

  override fun runAfter(duration: Duration, onlyIfActive: Boolean, runnable: () -> Unit) {
    window.setTimeout(runnable, duration.millis.toInt())
  }

  override fun openFirstValidUrl(urls: List<String>) {
    openUrl(urls.first { it.startsWith("http") })
  }

  override fun pushWebHistory(url: String, hash: String) {
    window.history.pushState(
      jsObj(),
      document.title,
      "$url#$hash"
    )
  }

  override fun goToSequence(sequenceId: String?) {
    pushViewController(LoadingViewController(sequenceId))
  }

  override fun goToPurchase(onPop: () -> Unit) = AppPage.goTo(AppPage.PURCHASE_URL)

  override fun goHomeOrOpenApp() =
    if (Browser.isPhone)
      window.location.href = buildString {
        append("https://")
        append(
          when (appType) {
            ORIGINAL -> ""
            INTRO,
            HIIT,
            BARRE,
            SEVEN,
            PRENATAL,
            MEDITATION,
            RUNNING,
            BREATHING,
            PILATES -> "${appType.name.lowercase()}-"
          }
        )
        append("link.downdogapp.com")
      }
    else
      AppPage.goTo(AppPage.HOME_URL)

  // In new tab or window
  override fun openUrl(url: String) {
    window.open(url, "_blank")
  }

  override fun getViewController(name: String) =
    AppPage.getViewControllers().find { it::class.simpleName == name }

  override fun closeKeyboard() {}

  override fun unwindToViewController(name: String, callback: () -> Unit) {
    AppPage.unwindToViewController(name, callback)
  }

  override fun updateFullscreen() {}

  override fun isBrowserSafari() = Browser.isSafari

  override fun isBrowserPhone() = Browser.isPhone

  override fun requestReview() {}

  override val aspectRatio: Double? = null

  override val platform get() = WEB

  override val debug: Boolean get() = AppPage.DEBUG

  override fun activatePlaybackSession(duckOthers: Boolean) {}
  override fun deactivatePlaybackSession() {}
  override fun setPlaybackState(isPlaying: Boolean, elapsedTime: Duration, playbackDuration: Duration) {}
  override fun setupPlaybackControls(onPlay: (() -> Unit)?,
                                     onPause: (() -> Unit)?,
                                     onChangePlaybackPosition: ((position: Double) -> Unit)?,
                                     onSkipForward: (() -> Unit)?,
                                     onSkipBackward: (() -> Unit)?) {
  }

  override fun exit() {}

  override fun payInApp(productId: String, purchaseViewController: PurchaseViewController) {}

  override fun payWithCreditCard(purchaseViewController: PurchaseViewController) {
    Network.post(
      PurchaseMembershipRequest(
        period = PurchaseView.productPeriod,
        currencyCode = PurchaseView.currencyCode!!,
        timezoneOffset = Date().getTimezoneOffset() / 60 // Converting minutes to hours
      )
    ) { json ->
      purchaseViewController.hideSpinner()
      val response =
        json?.let { StripeSessionResponse.fromJson(it) }

      if (response != null) {
        if (response.id != null) {
          Stripe.promptPurchase(
            sessionId = response.id,
            onError = purchaseViewController::onPurchaseFailed
          )
        } else {
          purchaseViewController.onPurchaseFailed(response.errorMessage)
        }
      } else {
        App.alertNoInternet()
      }
    }
  }

  override fun restorePurchases() {}

  override fun isBackgrounded() = false

  override fun getPrices(productIds: Set<String>, callback: (Map<String, YearlyMonthlyPricePair>) -> Unit) {
    callback(
      MANIFEST.membershipConfig
        .products
        .associate {
          it.productId to YearlyMonthlyPricePair(
            yearlyPriceString = it.price!!,
            monthlyPriceString = null
          )
        }
    )
  }

  override fun showShareDialog(url: String) {
    App.alert(title = Strings.SHARE, message = url)
  }

  override fun requestNotificationsAuthorization(callback: () -> Unit) {
    callback()
  }

  override fun preventSleep(value: Boolean) {}

  fun logout(callback: () -> Unit = {}) {
    UserPrefs.clear()

    val fb = js("window.FB")
    if (fb != undefined && fb.getAuthResponse() != undefined) {
      fb.logout {
        callback()
      }
    } else {
      callback()
    }
  }

  override fun logoutAccounts() {
    AppPage.spinnerShowing = true
    Network.post(LogoutRequest()) {
      if (it != null) {
        logout {
          App.goHomeOrOpenApp()
        }
      } else {
        App.alert(message = Strings.LOGOUT_NO_INTERNET_MESSAGE) {
          AppPage.spinnerShowing = false
        }
      }
    }
  }
}
